import { useEffect } from "react";

const OperatorModal = ({ operator }) => {
    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);
    return (
        <div
            className="modal fade m-0 p-0"
            tabIndex={-1}
            id={`machine-details-operator`}
            aria-modal
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <button className="close" data-bs-dismiss="modal">
                        <em
                            className="icon ni ni-cross"
                            aria-hidden="true"
                        ></em>
                    </button>
                    <div className="modal-header">
                        <h5 className="modal-title">Operator</h5>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-12 mb-2">
                                <p>
                                    <strong>Name</strong>: {operator?.name}
                                </p>
                            </div>
                            <div className="col-md-12 mb-2">
                                <p>
                                    <strong>From</strong>: {operator?.from}
                                </p>
                            </div>
                            <div className="col-md-12 mb-2">
                                <p>
                                    <strong>To</strong>: {operator?.to}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            data-bs-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OperatorModal;
